"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStore = void 0;
const mobx_1 = require("mobx");
const user_1 = require("@App/api/routes/user");
const groups_json_1 = __importDefault(require("@App/configs/static/groups.json"));
const features_json_1 = __importDefault(require("@App/configs/static/features.json"));
const jwt_1 = require("@App/enum/jwt");
const get_phone_number_display_1 = __importDefault(require("@App/helpers/work-entities/utils/get-phone-number-display"));
const get_country_title_1 = require("@App/helpers/get-country-title");
class UserStore {
    constructor(rootStore) {
        Object.defineProperty(this, "_userInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_userSettings", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                searchTermsAndConditions: false,
                showDetailedWorkCards: false,
                showWelcomePopup: false,
                showSongwriterHubPopup: false,
            }
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this, {
            _userInfo: mobx_1.observable,
            _userSettings: mobx_1.observable,
            phoneNumberDisplay: mobx_1.computed,
            countryTitle: mobx_1.computed,
            isInternal: mobx_1.computed,
            permissionGroupsFiltered: mobx_1.computed,
            address: mobx_1.computed,
            phoneNumber: mobx_1.computed,
            setUserViewedWelcomePopup: mobx_1.action,
            setUserSetting: mobx_1.action,
        });
        this.rootStore = rootStore;
    }
    get userInfo() {
        return this._userInfo;
    }
    // TODO: These can probably be factored out, because UserInfo has them.
    get userSettings() {
        return this._userSettings;
    }
    // TODO: These were changed to static json in MPOR-1968 - we should change to API calls w/ caching
    get permissionGroups() {
        return groups_json_1.default;
    }
    get permissionGroupsFiltered() {
        let filteredGroupData = groups_json_1.default;
        if (!this.isInternal) {
            filteredGroupData = filteredGroupData.filter((permission) => permission.id !== 'internal_user');
        }
        return filteredGroupData;
    }
    // TODO: These were changed to static json in MPOR-1968 - we should change to API calls w/ caching
    get permissionFeatures() {
        return features_json_1.default;
    }
    get phoneNumberDisplay() {
        return (0, get_phone_number_display_1.default)(this._userInfo);
    }
    get countryTitle() {
        return (0, get_country_title_1.getCountryTitle)(this.rootStore.libStore.countries, this._userInfo.country);
    }
    get isInternal() {
        return !!(this._userInfo && this._userInfo.isInternalUser);
    }
    get address() {
        const { streetAddress, unitNumber, city, state, country, postalCode } = this._userInfo;
        return {
            streetAddress: streetAddress,
            unitNumber: unitNumber || '',
            city: city,
            state: state || '',
            countryId: country ? String(country) : '',
            postalCode: postalCode ? postalCode : '',
        };
    }
    get phoneNumber() {
        const { phoneCountryCode, phoneAreaCode, phoneNumber } = this._userInfo;
        return {
            phoneCountryCode: String(phoneCountryCode),
            phoneAreaCode: phoneAreaCode ? phoneAreaCode : '',
            phoneNumber: phoneNumber,
        };
    }
    loadUserInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield (0, user_1.getUserInfo)();
            const data = response.data;
            data.isInternalUser = !!(data.groups && data.groups.find((aGroup) => aGroup.name === UserStore.internalGroupName));
            (0, mobx_1.runInAction)(() => (this._userInfo = data));
        });
    }
    createUser(newUser) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield (0, user_1.createUser)(newUser);
            const responseData = response.data;
            if (responseData.error === 'email_exists') {
                throw new Error('Email address already exists');
            }
            yield (0, user_1.attemptKyc)(responseData.id);
            return true;
        });
    }
    loadUserSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield (0, user_1.getUserSettings)();
            (0, mobx_1.runInAction)(() => (this._userSettings = response.data));
        });
    }
    setUserViewedSongwriterIntroPopup() {
        var _a;
        if ((_a = this._userSettings) === null || _a === void 0 ? void 0 : _a.showSongwriterHubPopup) {
            const setting = {
                parameter: 'showSongwriterHubPopup',
                value: false,
            };
            this.setUserSetting(setting).then();
        }
    }
    setUserViewedWelcomePopup() {
        var _a;
        if ((_a = this._userSettings) === null || _a === void 0 ? void 0 : _a.showWelcomePopup) {
            const setting = {
                parameter: 'showWelcomePopup',
                value: false,
            };
            this.setUserSetting(setting).then();
        }
    }
    setUserSetting(setting) {
        return __awaiter(this, void 0, void 0, function* () {
            this._userSettings[setting.parameter] = setting.value;
            const responseSettings = yield (0, user_1.setUserSetting)(setting);
            (0, mobx_1.runInAction)(() => 
            // Translate from SetSetting to UserSettings value
            responseSettings.data.settings &&
                responseSettings.data.settings.forEach((retrievedSetting) => {
                    if (retrievedSetting.parameter in this._userSettings) {
                        this._userSettings[retrievedSetting.parameter] = retrievedSetting.value;
                    }
                }));
        });
    }
    attemptKycForCurrentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.userInfo.id) {
                throw new Error('No user loaded - cannot KYC!');
            }
            try {
                yield (0, user_1.attemptKycAuth)(this.userInfo.id);
                return this.loadUserInfo();
            }
            catch (e) {
                yield this.loadUserInfo();
                throw e;
            }
        });
    }
    submitPhoneEnrollmentMfaCode(code) {
        return __awaiter(this, void 0, void 0, function* () {
            const mfaToken = localStorage.getItem(jwt_1.JWT_STORAGE_NAMES.mfaToken);
            const response = yield (0, user_1.submitPhoneEnrollmentMfaCode)(code, mfaToken ? mfaToken : '');
            localStorage.removeItem(jwt_1.JWT_STORAGE_NAMES.mfaToken);
            return response;
        });
    }
    enrollUser2fa(useSms, email, password, phoneCountryCode, phoneAreaCode, phoneNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield (0, user_1.enrollUser2fa)(useSms, email, password, phoneCountryCode, phoneAreaCode, phoneNumber);
            const data = result.data;
            localStorage.setItem(jwt_1.JWT_STORAGE_NAMES.mfaToken, data.mfa);
            return data && 'mfa' in data ? data.mfa : 'error';
        });
    }
    changeUserPassword(code, proposedPassword) {
        const accessToken = localStorage.getItem(jwt_1.JWT_STORAGE_NAMES.accessToken);
        return (0, user_1.changeUserPassword)(accessToken ? accessToken : '', code, proposedPassword);
    }
}
exports.UserStore = UserStore;
Object.defineProperty(UserStore, "internalGroupName", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'Internal User'
});
